module.exports = __webpack_public_path__ + "static/media/signup.8049109a.png";